import React from 'react'
import { useParams } from 'react-router-dom'
import { useState,useEffect } from 'react';
import ApiUrl from '../../../configTools/apiUrl';
import { Link } from 'react-router-dom';
import ScreenSizes from '../../../configTools/screenSizes';
import GreenButton from '../../../components/forms/greenButton';
import FormSelect from '../../../components/forms/formSelect';
import Button from '../../../components/forms/blackfillButton'


const View = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [Order,setOrder] = useState(0);
    const [Fulfillments,setFulfillments] = useState([]);
    const [showFulfill,setShowFulfill] = useState(false);
    const [city,setCity] = useState({name:'Select', value:'0'});
    const [cityList,setCityList] = useState([
        {name:'Lahore', value:'Lahore'},
        {name:'Islamabad', value:'Islamabad'},
        {name:'Rawalpindi', value:'Rawalpindi'},
        {name:'Karachi', value:'Karachi'},
        {name:'Faisalabad', value:'Faisalabad'}
    ]);
    const {id} = useParams();
    const width = window.innerWidth;
    const refrest_order = ()=>{
        fetch(ApiUrl.API_URL_Orders+'/'+id,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                setOrder(data.responce);
            }
        });
    }
    useEffect(()=>{
        refrest_order();
    },[id,User])
    useEffect(()=>{
        if(Order !== 0){
            if(Order.fulfilmentstatus !== 0){
                fetch(ApiUrl.API_URL_Fulfillment+"/"+Order.id)
                .then(res=>res.json())
                .then(data =>{
                    if(data.success){
                        setFulfillments(data.responce);
                    }
                });
            }
        }
    },[Order])

    const post_fulfillment = ()=>{
        if(city.value === '0'){
            return;
        }
        fetch(ApiUrl.API_URL_Fulfillment, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          },
          body: JSON.stringify({
            orderid:id,
            type:1,
            city:city.value
          })
        })
        .then(res=>res.json())
        .then(data =>{
          if(data.success){
            refrest_order();
          }
          else{
            console.log(data.responce);
            alert("Failed.");
          }
        });
    }

  return (
    <>
    <div className='admin_forms_row' style={{padding:"10px 0px"}}>
        <div className='admin_col_65' style={{padding:"0px 10px"}}>
        <div className='product_add_title'><h3>{Order !== 0 &&
        'Order# '+Order.orderno
        }</h3></div>
        </div>
        <div className='admin_col_35'>
        <div className='product_add_button_container'>
            {Order.fulfilmentstatus === 0 &&
                <GreenButton Value={'Fulfill'} Action={()=>{
                    setShowFulfill(true);
                }}/>
            }
        </div>
        </div>
    </div>
      {Order !== 0 &&
        <div className='admin_forms_row'>
            <div className={width > ScreenSizes.Mobile? 'admin_col_60' : 'admin_col_100'} style={width > ScreenSizes.Mobile?{
                padding:"0px 20px 0px 0px"
            }:{}}>
                <div className='admin_forms_container'>
                    <h1>Line Items</h1>
                    <div className='checkout_listings_items'>
                    {
                        Order.lineitems.map((item,index)=>{
                        return(
                            <div key={index} className='checkout_box_item'>
                            <div className='checkout_box_item_image'>
                                <div style={{
                                    width: "100%",
                                    paddingTop: "80%",
                                    borderRadius: "10px",
                                    position: "relative",
                                    backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                }}></div>
                            </div>
                            <div className='checkout_box_item_details'>
                                <Link to={"/product/"+item.slug}>
                                <h5>{item.title}</h5>
                                <p style={{fontSize:"12px", padding:"5px 0px"}}>{item.sku}</p>
                                </Link>
                                {item.hasvarients &&
                                <div className='checkout_box_item_details_container'>
                                    <div className='checkout_box_item_details_item'>
                                    <p>Size:</p>
                                    <p>{item.sizeName}</p>
                                    </div>
                                    <div className='checkout_box_item_details_item'>
                                    <p>Color:</p>
                                    <div style={{backgroundColor:item.colorcode}} className={"checkout_box_item_details_item_colorcode"}></div>
                                    </div>
                                </div>
                                }
                            </div>
                            <div className='checkout_box_item_price'>
                                <p>{"Rs."+item.price+"/-"}</p>
                            </div>
                            </div>
                        )
                        })
                    }
                    </div>
                </div>
            </div>
            <div className={width > ScreenSizes.Mobile?'admin_col_40':'admin_col_100'}>
                {Order.user !== 0 &&
                <div className='checkout_details_user_container' style={{margin:"0",padding:"20px 10px",backgroundColor:"white"}}>
                    <div className='checkout_details_user_image'>
                        <div style={{
                            width: "100%",
                            paddingTop: "80%",
                            borderRadius: "10px",
                            position: "relative",
                            backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Order.userdetails.image})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center'
                        }}>
                        </div>
                    </div>
                    <div className='checkout_details_user_details'>
                        <h3>{Order.userdetails.firstname+" "+Order.userdetails.lastname}</h3>
                        <h4>{"@"+Order.userdetails.username}</h4>
                    </div>
                </div>
                }
                {Order.fulfilmentstatus !== 0 &&
                <div className='admin_forms_container' style={{
                    marginTop:"10px"
                }}>
                    <h1>Fulfillment</h1>
                    {
                        Fulfillments.map((item,index)=>{
                            return(
                                <>
                                    <div className='order_details_deliver_item'>
                                        <h3>Tracking</h3>
                                        <p>{item.tracking}</p>
                                    </div>
                                    <div className='order_details_deliver_item'>
                                        <h3>Tracking Url</h3>
                                        <p>{item.trackingurl}</p>
                                    </div>
                                    <div className='order_details_deliver_item'>
                                        <h3>Company</h3>
                                        <p>{item.company === 1? "PostEx":""}</p>
                                    </div>
                                    <div className='order_details_deliver_item'>
                                        <h3>Creation time</h3>
                                        <p>{item.creationtime}</p>
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
                }
                <div>
                </div>
                <div className='admin_forms_container' style={{
                    marginTop:"10px"
                }}>
                    <h1>Status</h1>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Fulfilment</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.fulfilmentstatus===0?"Unfulfilled":"Fulfilled"}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Payment</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.paymentstatus===0?"Unpaid":"Paid"}</p></div>
                    </div>
                </div>
                <div className='admin_forms_container' style={{
                    marginTop:"10px"
                }}>
                    <h1>Delivery</h1>
                    <div className='order_details_deliver_item'>
                        <h3>Name</h3>
                        <p>{Order.name}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Email</h3>
                        <p>{Order.email}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Contact</h3>
                        <p>{Order.contact}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Address</h3>
                        <p>{Order.address}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Location</h3>
                        <p>{Order.locationValue}</p>
                    </div>
                </div>
                <div className='admin_forms_container' style={{
                    marginTop:"10px"
                }}>
                    <h1>Value</h1>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Net Total</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.total}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Shipping</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.sellershipping}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Commission</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.commission}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Payables</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.sellerpayables}</p></div>
                    </div>
                </div>
            </div>
        </div>
      }
      {showFulfill &&
        <div className='fulfillment_popup_wrapper'>
            <div className='fulfillment_popup_container'>
                <div className='fulfillment_popup_close'>
                    <button onClick={()=>{
                        setShowFulfill(false)
                    }}>X</button>
                </div>
                <div className='fulfillment_popup_form'>
                    <FormSelect Lable='City' Value={city} setValue={setCity} Options={cityList}/>
                    <Button Value={'Submit'} Action={post_fulfillment} />
                </div>
            </div>
        </div>
      }
    </>
  )
}

export default View
